
import {single} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';




const httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable()
export class MiscFunctionsService {

    constructor(private authService: AuthService, private http: HttpClient) {
    }

    public saveInternalRecords(requestID: number, reqCases: string): Promise<object> {
        if (this.authService.user.hasRole('employee')) {
            var body = {
                'requestID': requestID,
                'requestCases': reqCases,
            };
            var retVal = this.http.post('/api/service/saveInternalRecords/', body, httpOptions).pipe(single()).toPromise()
        }

        return retVal;
    }
}
